module.exports = __webpack_public_path__ + "static/media/dollar-sign.7a124bc7.png";